import { render, staticRenderFns } from "./ningdeSvg.vue?vue&type=template&id=28b2c9b8&scoped=true&"
import script from "./ningdeSvg.vue?vue&type=script&lang=js&"
export * from "./ningdeSvg.vue?vue&type=script&lang=js&"
import style0 from "./ningdeSvg.vue?vue&type=style&index=0&id=28b2c9b8&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b2c9b8",
  null
  
)

export default component.exports